









































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import A from '@/utilities/alpha'
import _ from 'lodash'
import generateCSV from '@/utilities/gen-csv.js'
import { Icon } from '@alpha/ink'
import SliceActions from '@/components/SliceActions.vue'
import DropdownButton from '@/components/DropdownButton.vue'
import ToucanFilter from './ToucanFilter.vue'
import * as ui from '@/types/frontend'
import analytics from '@/analytics'
import { getApiUrl } from '@/api'
import { NODE_ENV } from '@/config'
import FilterSVG from '@/assets/img/asset-type-icons/filter.svg?inline'

@Component({
  components: {
    Icon,
    SliceActions,
    ToucanFilter,
    DropdownButton,
    FilterSVG
  }
})
export default class InsightActions extends Vue {
  @Prop({ required: true }) insight!: ui.DynamicAsset | ui.DynamicQualAsset
  @Prop({ required: true }) allInsights!: ui.DynamicAsset[]
  @Prop({ required: true }) qualInsightCount!: number
  @Prop({ required: true }) json!: ui.DynamicAsset
  @Prop({ required: true }) savedFilterIndex!: number
  @Prop({ required: true }) currentFilter!: ui.TextFilter
  @Prop({ required: true }) topTerms!: ui.Term[]
  @Prop({ required: true }) showToucanFilter!: boolean
  @Prop({ required: true }) savingNewFilter!: boolean
  @Prop({ required: true }) originalTotalResponses!: number
  @Prop({ required: true }) isQualNotable!: boolean
  @Prop({ required: true }) loadingTextData!: boolean
  @Prop({ required: true }) activeSlice!: string
  @Prop({ required: true }) testId!: string

  urlNewTab = this.insight.url

  show = {
    toucan: false,
    moreOptions: false
  }

  downloadAssetTarget = NODE_ENV === 'development' ? '_blank' : '_self'

  toggle (key: keyof InsightActions['show'], value?: boolean): void {
    const newValue = (typeof value === 'undefined') ? !this.show[key] : value
    this.$set(this.show, key, newValue)
  }

  get showSavedFilters () {
    return this.showToucanFilter && this.json && this.json.filters && this.json.filters.length > 0
  }

  get assetTypeForDownload () {
    var type = this.insight.asset_type
    if (type === 'viz' || type === '') {
      return 'Download Image'
    } else if (type === 'textResponses' || type === 'textFrequency' || type === 'text-slice') {
      return 'Download Data'
    } else if (type === 'audio') {
      return 'Download Audio'
    } else {
      return 'Download Asset'
    }
  }

  get questionTypeToolTip () {
    if (this.insight.type && ['rank', 'single-select', 'multi-select'].includes(this.insight.type)) {
      return this.insight.type
        .split('-')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join('-') + '<br/> Question'
    }
    return false
  }

  get isText () {
    return this.insight.asset_type === 'textResponses' || this.insight.asset_type === 'textFrequency' || this.insight.asset_type === 'text-slice'
  }

  get isVideo () {
    return this.insight.asset_type === 'video'
  }

  get csvDownload () {
    // Really long insight file names were messing up on windows, so using unix epoch instead
    var filename = this.makeFilename()
    var csv: ui.CSVFile = { filename: filename, url: undefined }

    if (this.insight.hostedCsv) {
      csv.url = this.assetDownloadProxyURL(filename, this.insight.hostedCsv)
      csv.hosted = true
    } else if (this.json) {
      csv.url = 'data:text/csv;charset=utf-8,' + encodeURIComponent(A.stripNonASCII(generateCSV(this.json)))
    } else if (!this.insight.csv) {
      csv.url = undefined
    }

    return csv
  }

  get dynamicQual (): boolean {
    const isDynamicQual = !!(this.insight as ui.DynamicQualAsset).dynamicQual
    return isDynamicQual
  }

  get generatedURL () {
    var url = this.urlNewTab
    if (this.showToucanFilter && this.savedFilterIndex !== -1) {
      url += '?filters=' + this.savedFilterIndex
    }
    return url
  }

  get assetDownloadURL () {
    var url = this.generatedURL
    var filename = url.split('/').pop() as string
    return this.assetDownloadProxyURL(filename, url)
  }

  @Watch('insight', { deep: true })
  setNewTab () {
    if (this.activeSlice && this.insight.textResponses && this.insight.textResponses[this.activeSlice]) {
      this.urlNewTab = this.insight.textResponses[this.activeSlice].url
    } else {
      this.urlNewTab = this.insight.url
    }
  }

  isSliced (insight: ui.DynamicAsset) {
    return _.includes(['viz-slice', 'aud-slice', 'text-slice'], insight.asset_type)
  }

  makeFilename () {
    return new Date().getTime().toString() + '.csv'
  }

  updateURL (url: any) { // TODO:COLLIN set this after migrating slice actions
    this.urlNewTab = url.url
    this.$emit('updateURL', url)
  }

  prevInsight () {
    this.$emit('emitPrev')
    this.updateToucan({
      type: 'clearAll'
    })
  }

  nextInsight () {
    this.$emit('emitNext')
    this.updateToucan({
      type: 'clearAll'
    })
  }

  shrinkViewer () {
    this.$emit('emitShrink')
  }

  starText () {
    return this.insight.isHighlighted ? 'Highlighted Insight' : 'Highlight Insight'
  }

  updateToucan (data: { type: string, index?: number}) {
    this.$emit('updateToucan', data)
  }

  deleteWord (word: string, index: number) {
    this.$emit('updateToucan', {
      type: 'deleteKeyword',
      data: index
    })
  }

  selectFilter (index: number) {
    this.trackFilterSelected()
    this.updateToucan({
      type: 'selectFilter',
      index: index
    })
  }

  trackFilterOpenMenu () {
    analytics.track('Saved Filter Menu Opened', {
      testId: this.testId,
      insightId: this.insight.id,
      insightType: this.insight.asset_type
    })
  }

  trackFilterSelected () {
    analytics.track('Saved Filter Selected', {
      testId: this.testId,
      insightId: this.insight.id,
      insightType: this.insight.asset_type
    })
  }

  trackFilterDeleted () {
    analytics.track('Saved Filter Deleted', {
      testId: this.testId,
      insightId: this.insight.id,
      insightType: this.insight.asset_type
    })
  }

  trackMoreOptionsEvent () {
    analytics.track('More Options Toggled', {
      testId: this.testId,
      insightId: this.insight.id,
      insightType: this.insight.asset_type
    })
  }

  trackOpenInNewTabEvent () {
    analytics.track('Open in New Tab', {
      testId: this.testId,
      insightId: this.insight.id,
      insightType: this.insight.asset_type
    })
  }

  trackDownloadAssetEvent () {
    analytics.track('Download Asset', {
      testId: this.testId,
      insightId: this.insight.id,
      insightType: this.insight.asset_type
    })
  }

  trackExportAsCSVEvent () {
    analytics.track('Export as CSV', {
      testId: this.testId,
      insightId: this.insight.id,
      insightType: this.insight.asset_type
    })
  }

  backInsight () {
    this.$emit('backInsight')
  }

  assetDownloadProxyURL (filename: string, originalURL: string) {
    return getApiUrl('/assets/download/' + filename + '?url=' + encodeURIComponent(originalURL))
  }

  handleExportCSVClick (event: Event, csv: ui.CSVFile) {
    this.trackExportAsCSVEvent()
    // fix for IE 11+ (data blob uri's don't work)
    if (!this.insight.hostedCsv && this.json && window.navigator && window.navigator.msSaveOrOpenBlob) {
      var fileData = [generateCSV(this.json)]
      const blobObject = new Blob(fileData)
      window.navigator.msSaveOrOpenBlob(blobObject, csv.filename)
      return false
    }
  }
}
